/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';
import { jsx as _jsx } from "react/jsx-runtime";
const arrowDownRight = /*#__PURE__*/_jsx(SVG, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  children: /*#__PURE__*/_jsx(Path, {
    d: "M10 18h8v-8h-1.5v5.5L7 6 6 7l9.5 9.5H10V18Z"
  })
});
export default arrowDownRight;
//# sourceMappingURL=arrow-down-right.js.map